module.exports = __webpack_public_path__ + "static/media/JP.a312f3fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/JP.svg
// module id = 285
// module chunks = 0